export default __webpack_public_path__ + "static/media/icon-lang-dark.c3605b68.svg";